import React, { Component } from "react";
import { ColGrid, RowGrid } from "js/react/components/LayoutGrid";
import Button from "js/react/components/Button2";
import {
    Section,
    UIPane,
    UIPaneContents,
    UIPaneHeader
} from "js/react/components/UiComponents";
import CheckBox from "js/react/components/CheckBox";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ExportDialog from "js/react/views/PresentationSettings/dialogs/ExportDialog";
import { PdfCompressionTypes } from "common/constants";
import Banner from "js/Components/Banner";
import styled from "styled-components";
import { withTranslation } from "react-i18next";

const StyledBanner = styled(Banner)`
    background: transparent;
    border: 1px solid transparent;
    padding: 0;
`;

class ExportPane extends Component {
    state = { pdfCompressionType: "none" };

    componentDidMount() {
        // Check if we should auto-open the export dialog based on URL query parameter
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("openDialog") === "true") {
            this.export();
        }
    }

    export() {
        ShowDialog(ExportDialog, { presentation: this.props.presentation });
    }

    printToPDF() {
        const { pdfCompressionType } = this.state;
        this.props.presentation.printToPDF(pdfCompressionType);
    }

    handlePdfCompressionToggle = () => {
        this.setState({
            pdfCompressionType: this.state.pdfCompressionType === "none" ? PdfCompressionTypes.HIGH : "none"
        });
    }

    render() {
        const { pdfCompressionType } = this.state;
        const { t } = this.props;
        return (
            <UIPane className="export-pane">
                <UIPaneHeader>{t("Export Presentation")}</UIPaneHeader>
                <UIPaneContents>
                    <Section title={t("Export Presentation")}>
                        <RowGrid gap={20}>
                            <StyledBanner
                                headerText={t("Important: Exported presentations do not support animations or video at this time.")}
                                bodyText={t("Presentations exported without supported fonts will be converted to distinct font styles. Ensure fonts are downloaded to maintain parity.")}
                                showIcon={true}
                                iconType="warning"
                            />
                            <ColGrid>
                                <Button
                                    icon="cloud_download"
                                    onClick={() => this.export()}
                                    label={<><i style={{ marginRight: "10px" }}></i>{t("Export Presentation...")}</>}
                                    style={{ backgroundColor: "#11A9E2", fontFamily: "Source Sans Pro", fontSize: "14px", fontWeight: "600", borderRadius: "0px", padding: "10px 20px 10px 20px" }}
                                />
                            </ColGrid>
                        </RowGrid>
                    </Section>

                    <Section title={t("Print Presentation")}>
                        <RowGrid gap={20}>
                            {/* <ColGrid gap={10}>
                                <CheckBox
                                    value={pdfCompressionType !== "none"}
                                    onChange={this.handlePdfCompressionToggle}
                                    label={
                                        <span>Compress PDF - may result in lower image resolution.</span>
                                    }
                                />
                            </ColGrid> */}
                            <ColGrid>
                                <Button
                                    icon="print"
                                    label={<><i style={{ marginRight: "10px" }}></i>{t("Print Presentation...")}</>}
                                    onClick={() => this.printToPDF()}
                                    style={{ backgroundColor: "#11A9E2", fontFamily: "Source Sans Pro", fontSize: "14px", fontWeight: "600", borderRadius: "0px", padding: "10px 20px 10px 20px" }}
                                />
                            </ColGrid>
                            <h3>
                                <strong>{t("IMPORTANT")}:</strong> {t("Browser pop-up blockers may prevent Print Presentation from working. Please set your browser to allow pop-ups from www.beautiful.ai or click on the popup warning in your toolbar once Preparing to Print is completed.")}
                            </h3>
                        </RowGrid>
                    </Section>
                </UIPaneContents>
            </UIPane>
        );
    }
}

export default withTranslation()(ExportPane);
